import DoctorItem from "./DoctorItem";

const DoctorList = ({ doctors}) => {
  return (
    <div className="docotrs-page">
      <div className="container">
        <div className="doctor-list">
          {doctors?.map((doctor) => (
              <DoctorItem doctor={doctor} key={doctor._id} />
            ))}
        </div>
      </div>
    </div>
  );
};

export default DoctorList;
